// extracted by mini-css-extract-plugin
module.exports = {"list":"list__1vYLi","isMultiSelect":"isMultiSelect__2khAy","shaded":"shaded__3aRvF","embedded":"embedded__2PVVC","bordered":"bordered__etS-i"};